import { Link } from "gatsby";
import React from "react";
import TenjinLink from "./tenjinLink.js";
import { useLocation } from "@reach/router";
const NavbarLinks = ({ data, stackPages, stackMenuLabels, setShowModal }) => {
  const location = useLocation();

  const subMenu = [
    {name: stackMenuLabels['sources']      ?? stackPages?.sources?.title      ?? 'Sources', route: '/stacks/sources/'},
    {name: stackMenuLabels['destinations'] ?? stackPages?.destinations?.title ?? 'Destinations', route: '/stacks/destinations/'},
    {name: stackMenuLabels['analyses']     ?? stackPages?.analyses?.title     ?? 'Analyses', route: '/stacks/analyses/'},
  ];

  const logInItem = {
    title: "Log In",
    url: `${process.env.GATSBY_USER_PANEL_URL}/auth/login`
  }

  let menuItems = [];

  data.allWpMenuItem.edges.forEach((edge) => {
    menuItems.push(edge.node);
  });

  return (
    <>
      <ul className="hidden lg:flex lg:items-center lg:text-center lg:bg-transparent lg:h-auto lg:flex-row lg:pt-0 lg:pl-0">
        {menuItems.map((item, index) => {
          return (
            <li key={index} className="pb-3 lg:pb-0 text-sm">
              <TenjinLink
                item={item}
                className={`menu-item text-black font-normal md:py-7 md:inline-block ${
                  item.url === "/integrations/" ? "lg:px-4" : ""
                }`}
                activeClassName="active"
              />
            </li>
          );
        })}
        <li className="ml-12 pb-3 lg:pb-0 text-sm">
          <TenjinLink
            item={logInItem}
            className="menu-item text-black font-normal md:py-7 md:inline-block"
            activeClassName="active"
          />
        </li>
      </ul>
      {/* Sidebar -- start */}
      <div className="flex flex-col items-start h-screen pt-20 px-5 text-left bg-white lg:hidden ">
        <ul className="text-gray-800">
          {menuItems.map((item, index) => {
            return (
              <li key={index} className="pb-2 lg:pb-0 text-sm">
                <TenjinLink
                  item={item}
                  className={`menu-item font-normal md:inline-block ${
                    item.url === "/integrations/" ? "lg:px-4" : ""
                  }`}
                  activeClassName="active"
                />
                {item.url === "/stacks/" && <ul className="flex flex-col mt-1 text-font-primary ml-2">
                {subMenu.map((item, index) => {
                  return (
                    <Link
                      key={index}
                      to={item.route}
                      className={`text-xl py-1 md:inline-block ${
                        item.route === location.pathname ? "active" : ""
                      }`}
                    >
                      {item.name}
                    </Link>
                  );
                })}
              </ul>}
              </li>
            );
          })}
          <li className="mt-8 mb-4 lg:pb-0 text-sm">
            <TenjinLink
              item={logInItem}
              className="menu-item font-normal md:inline-block"
              activeClassName="active"
            />
          </li>
        </ul>
        <button
          className="px-8 py-2 mb-4 font-bold text-white rounded bg-black text-l w-full block lg:hidden md:w-content"
          onClick={() =>  window.location.href=`${process.env.GATSBY_USER_PANEL_URL}/auth/signup`}
        >
          Sign up
        </button>
        <button
          onClick={() => setShowModal(true)}
          className="px-8 py-2 font-bold text-white rounded bg-primary text-l w-full block lg:hidden md:w-content"
        >
          Book a demo
        </button>
      </div>
      {/* Sidebar -- end */}
    </>
  );
};

export default NavbarLinks;
